export const onlyNumber = [
  "phone","number","zip_code"
]


export const onlyName = [
  "name",
]